import React from "react";

const NotFound = () => {
  // 404 not found page for incorrect path
  return (
    <div className="mt-48">
      <h1 className="text-9xl font-medium text-red-600 mb-5">404</h1>
      <h1 className="text-5xl">Page Not Found</h1>
    </div>
  );
};

export default NotFound;
